export default function getDSN() {
  return 'https://499aaf86bcc84d88b2d40bfa33396794@o1172217.ingest.sentry.io/6267100';
}
